import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-151c8d72")
const _hoisted_1 = { class: "app-nav-footer" }
const _hoisted_2 = { class: "app-nav-footer-container" }
const _hoisted_3 = { class: "w-1/3 pl-2" }
const _hoisted_4 = { class: "w-1/3 flex justify-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 flex justify-end pr-2" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DarkModeToggle = _resolveComponent("DarkModeToggle")!
  const _component_AppNavToggle = _resolveComponent("AppNavToggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DarkModeToggle, { circle: "" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppNavToggle, { darkModeBg: "700" })
      ]),
      _hoisted_5
    ])
  ]))
}